import { useContext } from 'react';

import View from 'assets/icons/3d-view.png';
import FloorPlan from 'assets/icons/floor-plan.png';
import Gallery from 'assets/icons/gallery.png';
import Map from 'assets/icons/map-marker.png';
import MenuButton from 'components/MenuButton';
import { ContactModalContext } from 'context/contactModalContext';
import { TranslationContext } from 'context/translationContext';

import styles from './styles.module.scss';
import { Props } from './types';

const Navigation = ({ activeItem, onChange }: Props) => {
  const { t } = useContext(TranslationContext);
  const { openModal } = useContext(ContactModalContext);

  const handleBtnClick = () => {
    openModal('');
  };

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <MenuButton
          menuItem={0}
          activeItem={activeItem}
          onChange={onChange}
          imgSrc={View}
          label={t('threeDView')}
        />
        <MenuButton
          menuItem={1}
          activeItem={activeItem}
          onChange={onChange}
          imgSrc={Gallery}
          label={t('gallery')}
        />
        <MenuButton
          menuItem={2}
          activeItem={activeItem}
          onChange={onChange}
          imgSrc={FloorPlan}
          label={t('floorsPlan')}
        />
        <MenuButton
          menuItem={4}
          activeItem={activeItem}
          onChange={onChange}
          imgSrc={Map}
          label={t('map')}
        />
      </div>
      <button className={styles.btn} onClick={handleBtnClick}>
        {t('askForOffer')}
      </button>
    </div>
  );
};

export default Navigation;
